
export default {
  name: 'PageDogWash',

  data() {
    return {
      isMapReady: false,
      hasPaddocks: false,
      paddockEntranceGeoJson: {
        type: 'FeatureCollection',
        features: []
      }
    }
  },

  head() {
    return {
      title: 'Dog Wash',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Wash your Dog in just 10 minutes with the new Paw Paddock iClean.'
        }
      ]
    }
  },

  computed: {
    compHero() {
      return {
        title: 'Dog Wash',
        image: require('~/assets/images/backgrounds/dog-wash-hero.jpg'),
        alt: 'Dog covered in water'
      }
    },

    compDogWashPaddocks() {
      return this.$store.getters['paddocks/dogWashPaddocks']
    }
  },

  created() {
    this.$store.dispatch('paddocks/fetchAll')
  }
}
